import Title from "../components/TheTitle.vue";
import PointInfo from "../components/PointInfo.vue";
import ModalQrCode from "../components/QRModal.vue";
import { searchPointHistory, searchUser } from "../api";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "PointGrantResult",
    data() {
        return {
            tableInfo: [],
            pageSize: 100,
            infoPage: 1,
            pointBulkGrantHistoryId: "",
            sPResult: [],
            sUResult: [],
            show: false,
            type: "point",
            name: "",
            value: "",
        };
    },
    components: {
        Title,
        PointInfo,
        ModalQrCode,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        "$store.state.pointInfo": {
            handler(newVal) {
                if (newVal) {
                    this.name = newVal.point_name || "";
                    this.value = (newVal.points ?? "").toString();
                }
            },
            immediate: true,
        },
        // データが変更されたらページを先頭に戻す
        info() {
            this.infoPage = 1;
        },
    },
    async created() {
        const route = this.$route;
        const idFromParams = (route && route.params && route.params.id) || "";
        // 優先順位は params > query
        this.pointBulkGrantHistoryId = idFromParams || "";
        // 受け取った ID を使って API を呼ぶ
        if (!this.pointBulkGrantHistoryId)
            return;
        await this.callApi(this.pointBulkGrantHistoryId);
        await this.mergeInfo(this.sPResult, this.sUResult);
    },
    methods: {
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                return String(value);
            };
            const lines = [];
            // tableInfo から電話番号だけを1行ずつ出力（ヘッダなし）
            for (const t of this.tableInfo) {
                const num = (t.mobile_phone_number || "").replace(/-/g, "");
                lines.push(escapeCsv(num));
            }
            const csvContent = lines.join("\r\n");
            const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "ポイント付与結果_電話番号.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        openModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        async callApi(id) {
            // ポイント履歴検索APIを呼び出す
            const sPRspBody = await searchPointHistory(id, undefined, 0);
            if (sPRspBody.result?.code === 9) {
                if (sPRspBody.result?.messages) {
                    this.$store.commit("setMessages", sPRspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                return;
            }
            this.sPResult = sPRspBody.data?.results;
            // ユーザ検索APIを呼び出す
            const customerIds = this.sPResult.map((r) => r.crm_customer_id);
            if (customerIds.length) {
                const sURspBody = await searchUser(customerIds, null, null, null, null, null, null);
                if (sURspBody.result?.code === 9) {
                    if (sURspBody.result?.messages) {
                        this.$store.commit("setMessages", sURspBody.result.messages);
                        this.$store.commit("setCancelBtnHide", true);
                        this.$store.commit("setIsModalOpen", true);
                    }
                    return;
                }
                this.sUResult = sURspBody.data?.results;
            }
            else {
                this.sUResult = null;
            }
            return;
        },
        async mergeInfo(PointHistoryInfoList, UserInfoList) {
            // ユーザを crm_customer_id -> UserInfo の Map に変換
            const userMap = new Map();
            for (const u of UserInfoList) {
                if (u && u.crm_customer_id)
                    userMap.set(u.crm_customer_id, u);
            }
            // 日付をフォーマットするヘルパー
            const formatDatetime = (value) => {
                return FormatDate.withoutTzAndMs(value);
            };
            const merged = PointHistoryInfoList.map((p) => {
                const user = userMap.get(p.crm_customer_id);
                return {
                    crm_customer_id: p.crm_customer_id || "",
                    user_name: user?.name || "",
                    mobile_phone_number: user?.mobile_phone_number || "",
                    grant_type_detail: p.grant_type_detail || "",
                    history_date: formatDatetime(p.history_date),
                };
            });
            // 反映
            this.tableInfo = merged;
            return;
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
